import React from "react";
import Reports51 from "./Reports-5.1";
import ApiKeys from "./ApiKeys";
import {Navigate} from "react-router-dom";


export const routesConfig = [
  {
    path: "/",
    element: <Reports51 />,
    linkName: "Reports",
  },
  {
    path: "apikeys",
    element: <ApiKeys />,
    linkName: "Counter API (SUSHI)"
  },
  {
    path: "https://account.thieme.de/profile",
    linkName: "Profile",
    external: true
  },
  {
    path: "https://www.thieme-connect.de/products/all/contact",
    linkName: "Support",
    external: true
  },
  {
    path: "*",
    element: <Navigate to="/" />,
    linkName: "",
    hidden: true,
  }
];
